import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { createBrowserHistory } from 'history';

//import Auth from './auth/Auth';
import App from './App';
//import Callback from './auth/Callback';

// Initiate browser history for BrowserRouter
const history = createBrowserHistory();

const domain = "statelo.auth0.com";
const clientId = "NxeS0ckKMKTCtqKvr6QMavmxPzdGHJiI";
/*
const auth = new Auth();
const handleAuthentication = ({location}) => {
	if (/access_token|id_token|error/.test(location.hash)) {
		auth.handleAuthentication();
	}
}
*/

export const makeMainRoutes = () => {
	const isPrivateMode = !window.localStorage;
 	const isIpOrigin = /^[0-9.]+$/.test(window.location.hostname);

	return (
		<Auth0Provider 
			domain={domain}
			clientId={clientId}
      authorizationParams={{ redirect_uri: window.location.origin }}
      cacheLocation={isIpOrigin ? "memory" : "localstorage"}
		>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Auth0Provider>
	);
}


/*
			cacheLocation={isPrivateMode ? "memory" : "localstorage"}
				<Routes>
          <Route path="/" element={<App />} />
				</Routes>
*/

// google analytics
//import ReactGA from 'react-ga';
//ReactGA.initialize('UA-84480358-1'); 	//Unique Google Analytics tracking number

// function fireTracking() {
//function fireTracking() {

	// WARNING:  bundle.js:107003 [react-ga] path is required in .pageview()
	//console.log('FIRE TRACKING');
	//console.log('window.location.href');
	//console.log(window.location.href);
	//console.log(window.location.pathname);
	//console.log(window.location.search);

	// comment on localhost
//	ReactGA.pageview(window.location.href);

	// 2017-04-25: PP: added this line to try to prevent GA notification "La propriété Statelo n'enregistre aucun appel"
//	ReactGA.set({ page: window.location.href });
//	ReactGA.pageview(window.location.href);	

	// console.log('fireTracking: window.location.hash');
	// console.log(window.location.hash);
/*
	// comment on localhost
	ReactGA.pageview(window.location.hash);

	// 2017-04-25: PP: added this line to try to prevent GA notification "La propriété Statelo n'enregistre aucun appel"
  	ReactGA.set({ page: window.location.hash });
  	ReactGA.pageview(window.location.hash);
*/
//}

// const track = () => ReactGA.pageview(window.location.href);
/*
class TrackPageView extends React.Component {
  UNSAFE_componentWillMount() { fireTracking() }
  UNSAFE_componentWillUpdate() { fireTracking() }
  render() { return <Route children={this.props.children}/> }
}
*/